import getFeaturedItemImage from "./featuredItemImage";
import debounce from "./debounce";

const productCardAnchorHandler = (element) => {
  let target = [];
  if (element) {
    target = [element];
  } else {
    target = [...document.querySelectorAll(".product-card")];
  }

  target.forEach((card) => {
    const anchorTarget = card.querySelector("a[data-anchor-target]");
    if (!anchorTarget) return;

    card.addEventListener("click", (e) => {
      const { target } = e;
      e.preventDefault();

      if (
        target?.getAttribute("href") &&
        anchorTarget?.dataset?.anchorTarget !== "true"
      ) {
        return;
      } else {
        window.location.href = anchorTarget.getAttribute("href");
      }
    });
  });
};

export { productCardAnchorHandler, getFeaturedItemImage, debounce };
